import React from 'react'

export default function AssignPackagesEnquiryList() {
  return (
    <div>
      AssignPackagesEnquiryList
    </div>
  )
}
